var map = {
	"./account.svg": "lNpt",
	"./aftersale.svg": "CnjV",
	"./agreement.svg": "coBr",
	"./asset.svg": "S8k9",
	"./category.svg": "3HFE",
	"./clientManage.svg": "SCM8",
	"./code.svg": "IX5Q",
	"./config.svg": "e/UX",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./faq.svg": "i+/B",
	"./fullscreen.svg": "WIff",
	"./home.svg": "U9Ws",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./logisticsDelivery.svg": "+LR/",
	"./marketing.svg": "mkJ9",
	"./member.svg": "/LrJ",
	"./noStart.svg": "1yUe",
	"./operation.svg": "Dh6m",
	"./order.svg": "gYtG",
	"./page.svg": "zrC5",
	"./password.svg": "QjmH",
	"./place.svg": "82yd",
	"./product.svg": "UHi4",
	"./purchaseHelper.svg": "MMn8",
	"./seller.svg": "8S16",
	"./start.svg": "FCpx",
	"./system.svg": "Jax1",
	"./transferManag.svg": "+nhW",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 168